import { Pipe, PipeTransform } from '@angular/core';
import { NiveauEtude } from '../../models/niveauEtude';

@Pipe({
	name: 'filterNiveauEtudeByName'
})
export class FilterNiveauEtudeByNamePipe implements PipeTransform {
	transform(niveauEtude: NiveauEtude[], filter: string): NiveauEtude[] {
		if (
			!niveauEtude ||
			!filter ||
			niveauEtude === null ||
			filter === null ||
			filter === ''
		) {
			return niveauEtude;
		}

		return niveauEtude.filter((niveauEtude: NiveauEtude) => {
			if (niveauEtude.name) {
				// TODO: add lastName too
				return niveauEtude.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
